import React from "react";
import InfoSection from "@components/pages/info/info_section";

function ServiceNumber() {
    return (
        <InfoSection title="Fyrirtækjaskrá">
            <p>
                Fyrirt&aelig;kjaskr&aacute; 1819 byggir &aacute; uppl&yacute;singum fr&aacute;
                fyrirt&aelig;kjaskr&aacute; R&iacute;kisskattstj&oacute;ra,{" "}
                <a href="http://www.rsk.is/">www.rsk.is</a>, og getur 1819 &thorn;v&iacute; ekki
                bori&eth; &aacute;byrg&eth; &aacute; efni &thorn;eirra uppl&yacute;singa, n&eacute;
                tj&oacute;ni e&eth;a &oacute;&thorn;&aelig;gindum sem &thorn;&aelig;r kunna a&eth;
                valda. Mikilv&aelig;gt er a&eth; fyrirt&aelig;ki sj&aacute;i til &thorn;ess a&eth;
                r&eacute;tt kennitala fylgi me&eth; &ouml;llum skr&aacute;ningum.
            </p>
        </InfoSection>
    );
}
export default ServiceNumber;
